import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.652 6.83998L17.16 0.347974C16.932 0.119974 16.632 0 16.308 0H2.4C1.08 0 0 1.08 0 2.4V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V7.692C24 7.368 23.868 7.05598 23.652 6.83998ZM21.6 20.388C21.6 21.048 21.06 21.588 20.4 21.588H3.6C2.94 21.588 2.4 21.048 2.4 20.388V3.58799C2.4 2.92799 2.94 2.38799 3.6 2.38799H14.4V7.18799C14.4 8.50799 15.48 9.58799 16.8 9.58799H21.6V20.388Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
